var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dragShadow",attrs:{"id":"DragShadow"}},[(_vm.dragData)?_c('SimplePin',{attrs:{"pin":_vm.dragData.pin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }